export default [
  {
    for: 'label',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
];
